/**
 * Whether a sensor has ever sent a reading. A sensor is registered with its
 * temperature, humidity, battery voltage and signal all at 0, and only a
 * check-in writes them, so one with every one of them still at 0 has never
 * reported. The API returns temperature and humidity with the calibration
 * offsets added (the temperature offset in the user's unit), so those two
 * are compared against what a 0 reading comes back as.
 */
const hasSensorReported = sensor => {

  const num = value => parseFloat(value) || 0;
  const isZero = (value, zero = 0) => Math.abs(num(value) - zero) < 0.05;

  const tempOffset = num(sensor.temp_offset);
  const zeroTemp = window.getUserTempPref() === 'F' ? tempOffset / 1.8 : tempOffset;

  return !(
    isZero(sensor.last_temp, zeroTemp) &&
    isZero(sensor.last_humidity, num(sensor.humidity_offset)) &&
    isZero(sensor.last_voltage) &&
    isZero(sensor.rssi)
  );

}

export default hasSensorReported;
